import { DEFAULT_CURRENCY_CODE, NgModule } from "@angular/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { DateAdapter, MatNativeDateModule, MatRippleModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from "@angular/material/form-field";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { LlwythwrComponent } from "./llwythwr/llwythwr.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NavbarDefnyddiwrComponent } from "./navbar-defnyddiwr/navbar-defnyddiwr.component";
import { FontAwesomeModule, FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { AnghywirComponent } from "./anghywir/anghywir.component";

import { DragDropModule } from "@angular/cdk/drag-drop";
import { DeialogIaNaComponent } from "./deialog-ia-na/deialog-ia-na.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LlwythwrService } from "src/app/craidd/gwasanaethau/system/llwythwr.service";
import { SidenavService } from "src/app/craidd/gwasanaethau/system/sidenav.service";
import { UwchlwythoFfeilComponent } from "./uwchlwytho-ffeil/uwchlwytho-ffeil.component";
import { DateTimeAdapter, OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from "@danielmoncada/angular-datetime-picker";
import { StorfaDefnyddiwrService } from "src/app/craidd/gwasanaethau/system/storfa-defnyddiwr.service";
import { OwlDateTimeIaithServiceService } from "src/app/craidd/gwasanaethau/system/owl-date-time-iaith-service.service";
import { IaithService } from "src/app/craidd/gwasanaethau/iaith/iaith.service";
import { MtxDatetimepickerModule } from "@ng-matero/extensions/datetimepicker";
import { DatetimeAdapter, MtxNativeDatetimeModule, MTX_DATETIME_FORMATS } from "@ng-matero/extensions/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MomentDatetimeAdapter } from "@ng-matero/extensions-moment-adapter";
import { OwlMomentDateTimeModule } from "@danielmoncada/angular-datetime-picker-moment-adapter";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { AdroddProblemComponent } from "./adrodd-problem/adrodd-problem.component";
import { UiRoutingModule } from "./ui-routing.module";
import { SidebarDewislenComponent } from "./sidebar-dewislen/sidebar-dewislen.component";
import { HawlfraintComponent } from "./hawlfraint/hawlfraint.component";
import { TeitlTudalenComponent } from "./teitl-tudalen/teitl-tudalen.component";
import { BwletinNewyddComponent } from "./bwletin-newydd/bwletin-newydd.component";

const appearance: MatFormFieldDefaultOptions = {
  appearance: "outline",
};

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LocalizeRouterModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatFormFieldModule,
    CommonModule,
    FontAwesomeModule,
    FlexLayoutModule,
    DragDropModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MtxDatetimepickerModule,
    MtxNativeDatetimeModule,
    UiRoutingModule,
    LlwythwrComponent,
    SidebarComponent,
    SidebarDewislenComponent,
    HawlfraintComponent,
    NavbarComponent,
    NavbarDefnyddiwrComponent,
    AnghywirComponent,
    DeialogIaNaComponent,
    UwchlwythoFfeilComponent,
    AdroddProblemComponent,
    TeitlTudalenComponent,
    BwletinNewyddComponent,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatFormFieldModule,
    LlwythwrComponent,
    SidebarComponent,
    NavbarComponent,
    FontAwesomeModule,
    FlexLayoutModule,
    DragDropModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    MtxDatetimepickerModule,
    MtxNativeDatetimeModule,
    TeitlTudalenComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        minWidth: "60%",
        hasBackdrop: true,
      },
    },
    // {
    //     provide: DateTimeAdapter,
    //     useClass: MomentDateTimeAdapter,
    //     deps: [OWL_DATE_TIME_LOCALE]
    // },
    {
      provide: OWL_DATE_TIME_FORMATS,
      useValue: {
        parseInput: "DD/MM/YYYY",
        fullPickerInput: "DD/MM/YYYY HH:mm",
        datePickerInput: "DD/MM/YYYY",
        timePickerInput: "HH:mm",
        monthYearLabel: "MMMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
      },
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "DD/MM/YYYY",
        },
        display: {
          dateInput: "DD/MM/YYYY",
          monthYearLabel: "YYYY MMM",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "YYYY MMM",
        },
      },
    },
    {
      provide: DatetimeAdapter,
      useClass: MomentDatetimeAdapter,
    },
    {
      provide: MTX_DATETIME_FORMATS,
      useValue: {
        parse: {
          dateInput: "DD/MM/YYYY",
          monthInput: "MMMM",
          timeInput: "HH:mm",
          datetimeInput: "DD/MM/YYYY HH:mm",
        },
        display: {
          dateInput: "DD/MM/YYYY",
          monthInput: "MMMM",
          timeInput: "HH:mm",
          datetimeInput: "DD/MM/YYYY HH:mm",
          monthYearLabel: "YYYY MMMM",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
          popupHeaderDateLabel: "MMM DD, ddd",
        },
      },
    },
    {
      provide: OwlDateTimeIntl,
      useClass: OwlDateTimeIaithServiceService,
      deps: [TranslateService, IaithService, StorfaDefnyddiwrService, DateTimeAdapter],
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: "GBP",
    },
    LlwythwrService,
    SidenavService,
  ],
})
export class UiModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
  }
}
